module.exports = __webpack_public_path__ + "img/applicationresults_gj01.68439a75.png";